module.exports = __webpack_public_path__ + "img/sheep_des_3.d8a847f7.jpg";